module.exports = __webpack_public_path__ + "assets/4253e4dfb45244ceec5a9208c8e2126a.png";